import React, { createContext, useEffect, useState } from "react";
import { HubConnectionBuilder, LogLevel } from "@microsoft/signalr";
import { env } from "configs/EnvironmentConfig";
import { message } from "antd";
import { useSelector } from "react-redux";

export const SignalRContext = createContext({
  connection: null,
  status: "disconnected",
});

export const SignalRProvider = ({ children }) => {
  const [connection, setConnection] = useState(null);
  const [status, setStatus] = useState("disconnected");
  const authData = useSelector((state) => state.auth);

  useEffect(() => {
    let authToken = authData.token;

    if (connection) {
      connection.stop();
      setConnection(null);
      setStatus("disconnected");
    }
    if (!authToken) return;

    const newConnection = new HubConnectionBuilder()
      .withUrl(`${env.API_ENDPOINT_URL}hubs/notifications`, {
        accessTokenFactory: () => {
          return authToken;
        },
      })
      .withAutomaticReconnect([1000, 1000 * 20, 1000 * 60])
      .configureLogging(LogLevel.Information)
      .build();

    setConnection(newConnection);
  }, [authData]);

  useEffect(() => {
    if (!connection || !authData.token) return;

    if (connection.state === "Connected" || connection.state === "Connecting") {
      return;
    }

    connection.onreconnecting((error) => {
      console.warn("SignalR reconnecting...", error);
      setStatus("reconnecting");
    });

    connection.onreconnected((connectionId) => {
      console.log("SignalR reconnected!", connectionId);
      setStatus("connected");
    });

    connection.onclose((error) => {
      console.error("SignalR connection closed.", error);
      setStatus("disconnected");
    });

    // Connect to SignalR
    const startConnection = async () => {
      try {
        await connection.start();
        message.success("Live Updates enabled");
        setStatus("connected");
      } catch (err) {
        console.error("SignalR Connection Error: ", err);
        setStatus("disconnected");
        message.error("Cannot receive Live Updates. Retrying...");
        setTimeout(() => {
          startConnection();
        }, 30000);
      }
    };

    startConnection();

    return () => {
      connection.stop();
    };
  }, [connection, authData.token]);

  return (
    <SignalRContext.Provider value={{ connection, status }}>
      {children}
    </SignalRContext.Provider>
  );
};
